import { useTranslation } from "react-i18next";
import CircleButton from "../buttons/CircleButton";
import { ViewerSmallButton } from "../viewer/Timeline";

const CadastralControls = ({
  onToggleClick,
  onApplyOffsetClick,
  cadastralVisible,
}) => {
  const { t } = useTranslation("pages");

  return (
    <div className="absolute bottom-16 left-12 z-10 flex flex-col gap-3">
      {cadastralVisible && (
        <ViewerSmallButton
          onClick={onApplyOffsetClick}
          className="flex items-center justify-center px-10"
        >
          {t("mapViewPage.cadastreAlign")}
        </ViewerSmallButton>
      )}

      <CircleButton
        onClick={() => onToggleClick(!cadastralVisible)}
        primary={cadastralVisible ? false : true}
        className="w-[42px] h-[42px] shadow-sm shadow-[#ddd]"
        icon={
          cadastralVisible
            ? "/images/layers_icon_primary.svg"
            : "/images/layers_icon_white.svg"
        }
      />
    </div>
  );
};

export default CadastralControls;
